import styled, { createGlobalStyle } from 'styled-components'

export const CreatePositionModalGlobalStyle = createGlobalStyle`
  .create-position-modal {
    .ant-modal-content {
      border-radius: 12px !important;
      overflow: hidden;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    }

    .ant-modal-header {
      padding: 18px 24px !important;
      border-bottom: 1px solid #f1f5f9 !important;
      background: #ffffff !important;
    }

    .ant-modal-title {
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 18px !important;
      font-weight: 600 !important;
      color: #0f172a !important;
    }

    .ant-modal-close {
      top: 18px !important;
      right: 20px !important;
      color: #64748b !important;

      &:hover {
        color: #0f172a !important;
      }
    }

    .ant-modal-body {
      padding: 24px !important;
    }
  }
`

export const CreatePositionModalWrapper = styled.div`
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-form-item-label > label {
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    color: #334155 !important;
    margin-bottom: 4px;
  }

  .ant-input {
    height: 40px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    padding: 0 14px !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

    &:hover {
      border-color: #93c5fd !important;
    }

    &:focus,
    &.ant-input-focused {
      border-color: #70aefb !important;
      box-shadow: 0 0 0 2px rgba(112, 174, 251, 0.2) !important;
    }
  }
`

export const ModalFooterGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;

  .btn-cancel {
    height: 38px !important;
    padding: 0 18px !important;
    border-radius: 8px !important;
    border: 1px solid #e2e8f0 !important;
    color: #475569 !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #ffffff !important;
    transition: all 0.2s ease !important;

    &:hover {
      border-color: #cbd5e1 !important;
      background: #f8fafc !important;
      color: #1e293b !important;
    }
  }

  .btn-submit {
    height: 38px !important;
    padding: 0 22px !important;
    border-radius: 8px !important;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    background: #1d68a5 !important;
    border-color: #1d68a5 !important;
    color: #ffffff !important;
    box-shadow: 0 2px 6px rgba(29, 104, 165, 0.2) !important;
    transition: all 0.2s ease !important;

    &:hover {
      background: #155589 !important;
      border-color: #155589 !important;
      box-shadow: 0 4px 12px rgba(29, 104, 165, 0.3) !important;
    }
  }
`
